class ManageSessionStorage {
    __keyItem;
    constructor(keyItem, initialValue) {
        this.__keyItem = keyItem;
        if (sessionStorage.getItem(this.__keyItem) == null) {
            sessionStorage.setItem(this.__keyItem, initialValue);
        }
    }

    get data() {
        const retrievedObject = sessionStorage.getItem(this.__keyItem);
        return retrievedObject;
    }

    set items(item) {
        sessionStorage.setItem(this.__keyItem, item);
    }
}

export default ManageSessionStorage;